import { createFileRoute } from "@tanstack/react-router";

import { ArtifactDashboardPage } from "../tools/dashboards/artifacts/ArtifactDashboardPage";
import { SALES_ENROLLMENT_DASHBOARD_SLUG } from "../tools/dashboards/catalog";

export const Route = createFileRoute("/_app/dashboards/sales")({
  component: () => (
    <ArtifactDashboardPage slug={SALES_ENROLLMENT_DASHBOARD_SLUG} showAuthoringControls={false} />
  ),
});
